export default "__VITE_ASSET__C8Yx8DDQ__"